import { FC } from "react";
import { createPortal } from "react-dom";

import { t } from "i18n/i18n";
import { Modal, showModalWithProviders } from "mds/components/Modal";

export type StopPresentingForAssessmentModalProps = {
  open: boolean;
  onCancel: () => void;
  onContinue: () => void;
};

export const StopPresentingForAssessmentModal: FC<StopPresentingForAssessmentModalProps> = ({
  open,
  onCancel,
  onContinue,
}) => {
  if (!open) return null;

  return (
    <>
      {createPortal(<div className="modal-backdrop z-[10000]" onClick={onCancel} />, document.body)}
      <Modal
        cancelButtonText={t("common.cancel")}
        className="confirm-modal z-[10001]"
        confirmButtonText={t("common.continue")}
        labelText={t("assessment.stop_presenting_for_assessment_modal.description")}
        title={t("assessment.stop_presenting_for_assessment_modal.title")}
        onCancel={onCancel}
        onClose={onCancel}
        onConfirm={onContinue}
      />
    </>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const showStopPresentingForAssessmentModal = (): Promise<boolean> =>
  new Promise((resolve) => {
    showModalWithProviders((unmount) => (
      <StopPresentingForAssessmentModal
        open
        onCancel={() => {
          unmount();
          resolve(false);
        }}
        onContinue={() => {
          unmount();
          resolve(true);
        }}
      />
    ));
  });
